var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFemale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.503,
    height: 86,
    viewBox: "0 0 81.503 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12853",
    "data-name": "Group 12853",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3268",
    "data-name": "Path 3268",
    d: "M72.4,64.2h0L55.7,56.8a2.7,2.7,0,0,1-.8-.7l14.2-4.7h0a1.834,1.834,0,0,0,1-.7l.1-.2a1.721,1.721,0,0,0,.2-1.2h0v-.1h0V49h0c-1.9-8.7-8.2-37.3-11.9-41.5h0C54.7,3.2,47.8.4,40.8.4S26.9,3.3,23.2,7.6c-3.6,4.1-12.8,40.6-12.5,42.3A1.828,1.828,0,0,0,12,51.4l13.2,4.5a2.336,2.336,0,0,1-.7.7L8.8,64.1H8.7A15.743,15.743,0,0,0,.5,77.9v.3a7.17,7.17,0,0,0,7.2,7.2H73.8A7.17,7.17,0,0,0,81,78.2,15.3,15.3,0,0,0,72.4,64.2Z",
    transform: "translate(-0.5 -0.4)",
    fill: "none",
    stroke: "#ff0080",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M73.3,31.5H7.2A7.171,7.171,0,0,1,0,24.3V24A15.76,15.76,0,0,1,8.2,10.2h.1L24,2.7a2.332,2.332,0,0,0,.7-.7L18.831,0H61.047L54.4,2.2a2.687,2.687,0,0,0,.8.7l16.7,7.4a15.4,15.4,0,0,1,6.325,5.725A15.221,15.221,0,0,1,80.5,24.3a7.172,7.172,0,0,1-7.2,7.2Z",
    transform: "translate(0 53.5)",
    fill: "rgba(255,0,128,0.2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/female.905329608eeebc0e1dadf914ec8d7a17.svg";
export { ForwardRef as ReactComponent };